import { createSelector } from "@reduxjs/toolkit";

export const selectPostState = (state) => state.postState;

export const getSinglePost = createSelector(selectPostState,(postState) => postState.commonPost.post);
export const getAllPosts = createSelector(selectPostState,(postState) => postState.commonPost.posts);
export const getPostActions = createSelector(selectPostState,(postState) => postState.commonPost.act);
export const getPostCategory = createSelector(selectPostState,(postState) => postState.commoncategory.categories);